"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockwellContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _emittery = _interopRequireDefault(require("emittery"));
class BlockwellContext {
  constructor() {
    (0, _defineProperty2.default)(this, "events", new _emittery.default());
    (0, _defineProperty2.default)(this, "account", void 0);
    (0, _defineProperty2.default)(this, "chainId", 0);
    (0, _defineProperty2.default)(this, "type", "wallet");
  }
}
exports.BlockwellContext = BlockwellContext;
//# sourceMappingURL=BlockwellContext.js.map